import React, { useCallback, useState } from 'react';

interface EditorHotbarProps {
    children: React.ReactNode,
}

interface EditorHotbarContextValue {
    setActiveElement: (id: string, element: JSX.Element) => void,
    id?: string,
}

export const EditorHotbarContext = React.createContext<EditorHotbarContextValue>({
    // eslint-disable-next-line no-console
    setActiveElement: () => console.error('no editorhotbar context set'),
});

const EditorHotbar = ({ children }: EditorHotbarProps) => {
    const [activeElement, setActiveElement] = useState<{id: string, element: JSX.Element }>();

    const handleActiveElementSet = useCallback((id: string, element: JSX.Element) => {
        if(activeElement && activeElement.id === id) {
            setActiveElement(undefined);
            return;
        }
        setActiveElement({ id, element });
    }, [activeElement]);
    return (
        <EditorHotbarContext.Provider value={{ setActiveElement: handleActiveElementSet, id: activeElement?.id }}>
            <div className="absolute bottom-0 left-0 right-0 flex justify-center pointer-events-none">
                <div
                    className={
                        'bg-deep-blue basis-12 h-24 rounded-tl-xl'
                        + ' rounded-tr-xl pointer-events-auto flex flex-row '
                    }
                >
                    {children}
                    {activeElement?.element && (
                        <div className="absolute bottom-full left-1/2 -translate-x-1/2">
                            {activeElement.element}
                        </div>
                    )}
                </div>
            </div>
        </EditorHotbarContext.Provider>
    );
};

export default EditorHotbar;
